export const API = {
    MENU: '/api/menu',
    MENU_AVAILABILITY: '/api/menu/availability',
    MENU_STREAM: '/api/menu/stream',
    CHECKOUT: '/api/checkout',
    CHECKOUT_LOAD: '/api/checkout/load',
    AVAILABILITY: '/api/availability',
    FOOD_VARIANTS: '/api/food-catalog',
    MENUS: '/api/menus',
    CONTACT: '/api/contact',
} as const;
